/*
  HERO SLIDESHOW - 2026-09-10

  Autoplay no longer starts until the SECOND slide's image has actually loaded.

  Why: Lighthouse mobile showed LCP at 40.9s. The hero itself painted at 2s,
  but autoplay switched to slide 2 whose image was still downloading (it was
  lazy-loaded and queued behind several very large files). When it finally
  painted, Chrome recorded that as the largest contentful paint. For real
  customers this is the same thing as the slider flipping to a blank slide on
  a slow connection.

  Gating autoplay on the image being ready means the slider never advances to
  a slide it cannot show. On a normal connection the image is ready in well
  under the autoplay delay, so behaviour is unchanged.
*/
document.addEventListener('DOMContentLoaded', function () {

  const heroSlider = document.querySelector('.hero-slider');

  if (!heroSlider || typeof Swiper === 'undefined') return;

  const autoplayEnabled =
    heroSlider.dataset.autoplay === 'true';

  const autoplaySpeed =
    parseInt(heroSlider.dataset.speed || 5000);

  // Grab the original slides BEFORE Swiper initialises - with loop: true it
  // clones slides, which would make nth-child lookups unreliable afterwards.
  const originalSlides = Array.from(
    heroSlider.querySelectorAll('.swiper-wrapper > .hero-slide')
  );

  const swiper = new Swiper('.hero-slider', {
    loop: true,
    speed: 800,
    slidesPerView: 1,
    spaceBetween: 0,

    autoplay: autoplayEnabled
      ? {
          delay: autoplaySpeed,
          disableOnInteraction: false
        }
      : false,

    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });

  if (!autoplayEnabled || originalSlides.length < 2 || !swiper.autoplay) return;

  // Hold autoplay until slide 2 can be shown.
  swiper.autoplay.stop();

  const nextImage = originalSlides[1].querySelector('.hero-image img');

  const startAutoplay = function () {
    if (swiper.destroyed) return;
    swiper.autoplay.start();
  };

  if (!nextImage) {
    startAutoplay();
    return;
  }

  if (nextImage.complete && nextImage.naturalWidth > 0) {
    startAutoplay();
  } else {
    nextImage.addEventListener('load', startAutoplay, { once: true });
    // A broken image should not leave the slider frozen on slide 1 forever.
    nextImage.addEventListener('error', startAutoplay, { once: true });
  }

});
